import classNames from "classnames";
import { UrlObject } from "node:url";
import React from "react";
import Link from "next/link";
import { Routes } from "generated/routes";

import { Icon } from "../../atoms/icon";
import styles from "./index.module.scss";

interface Breadcrumb {
  label?: string;
  home?: boolean;
  to?: UrlObject | string;
}

interface Props {
  breadcrumbs?: Breadcrumb[];
}

interface BreadcrumbProps extends Breadcrumb {
  isActive: boolean;
}

const MAX_LENGTH = 10;

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  label = "",
  home = false,
  to = Routes.url("/", {}),
  isActive,
}) => {
  const shortenedLabel = `${label.substr(0, MAX_LENGTH)}${
    label.length >= MAX_LENGTH ? "..." : ""
  }`;
  const content = home ? <Icon name="home" /> : shortenedLabel;

  if (isActive) {
    return (
      <span className={styles.breadcrumb}>
        <Link href={to}>
          <span
            className={classNames(styles.label, styles.active, {
              [styles.icon]: home,
            })}
          >
            {content}
          </span>
        </Link>
      </span>
    );
  } else {
    return (
      <span className={styles.breadcrumb}>
        <span className={classNames(styles.label, { [styles.icon]: home })}>
          {content}
        </span>
      </span>
    );
  }
};

const Breadcrumbs: React.FC<Props> = (props) => {
  const { breadcrumbs = [] } = props;

  return (
    <div className={styles.breadcrumbs}>
      <Breadcrumb home to={Routes.url("/", {})} isActive={true} />
      {breadcrumbs.map((breadcrumb: Breadcrumb, index: number) => {
        const { label, to } = breadcrumb;
        return (
          <Breadcrumb
            label={label}
            to={to}
            isActive={index < breadcrumbs.length - 1}
            key={index}
          />
        );
      })}
    </div>
  );
};

export { Breadcrumbs };
